/**
 * Represents a log level.
 */
export enum ELogLevel {
    error,
    warn,
    info,
    debug
}


// WEBPACK FOOTER //
// ./src/core/helpers/logging/ELogLevel.ts